export default __webpack_public_path__ + "static/media/Deed of Contract_02.d65c3dc7.jpg";